import { useState } from "react";
import { createPortal } from "react-dom";
import { CustomButton } from "~/components";
import { clientApi } from "~/utils";
import { URL_PRIVACY } from "~/configs/consts";
import { METRIC_PROGRAMS_ACCEPT } from "~/pages/questionnaires/v1/customer/api/apiUrls";
import styles from "./PartnerMetricProgramsBanner.module.scss";

const BANNER_TEXT_BEFORE_LINK =
  "Для улучшения работы сайта с помощью Метрических программ обрабатываем данные о " +
  "взаимодействии с сайтом, включая cookie. Оставаясь с нами или нажимая «ОК», вы даете " +
  "согласие на такую обработку. Подробнее — в ";
const BANNER_LINK_TEXT = "Политике конфиденциальности";

const BANNER_TEXT = `${BANNER_TEXT_BEFORE_LINK}${BANNER_LINK_TEXT}`;

interface MetricProgramsBannerProps {
  clientId?: string;
}

export const PartnerMetricProgramsBanner = ({ clientId }: MetricProgramsBannerProps) => {
  if (import.meta.env.VITE_APP_ENV === "development") {
    return;
  }
  const [isAccepted, setIsAccepted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasError, setHasError] = useState(false);

  const shouldShow = !!clientId && !isAccepted;

  if (!shouldShow) return null;

  const handleAccept = async () => {
    setIsSubmitting(true);
    setHasError(false);
    try {
      await clientApi.post(METRIC_PROGRAMS_ACCEPT, {
        questionnaire_uid: clientId,
        banner_text: BANNER_TEXT,
      });
    } catch (e) {
    } finally {
      setIsAccepted(true);
      setIsSubmitting(false);
    }
  };

  return createPortal(
    <div className={styles.wrap} role="dialog" aria-live="polite" aria-label="Согласие на обработку данных">
      <div className={styles.card}>
        <p className={styles.text}>
          {BANNER_TEXT_BEFORE_LINK}
          <a href={URL_PRIVACY} target="_blank" rel="noopener noreferrer" className={styles.link}>
            {BANNER_LINK_TEXT}
          </a>
        </p>
        <CustomButton
          type="button"
          name="ОК"
          onClick={handleAccept}
          isLoading={isSubmitting}
          disabled={isSubmitting}
          className={styles.button}
        />
      </div>
    </div>,
    document.body
  );
};
